export const adaptUsersResponse = (response) => {
  return response?.response?.map((_user) => {
    return { value: _user?.email, label: _user.email };
  });
};
